import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const AircraftConfigurationRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--aircraft-configuration']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
